<template>
  <div>
    <h2 class="bb-page-title">Partner Payouts</h2>
    <div class="bb-partners-balance">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div class="bb-partners-balance-header">
      <total-card v-for="total in totalsInvoicesCard" :key='total.id'
                  class="bb-partners-balance-header-total"
                  :title="total.title"
                  :icon="total.icon"
                  :sum="total.sum"
                  :info="total.info"
                  :colorSum="total.color"/>
        <transition name="form-fade">
          <div class="bb-partners-balance-header-select" v-if="partnersName.length">
            <custom-select ref="partnersName"
                           :list="partnersName"
                           :filter-list="true"
                           :table-mode="true"
                           styles="high"
                           @setValue="setPartner"
                           :default-val="placeholderSelect"/>
          </div>
        </transition>
      </div>
      <Table :options="options" :totalPages="fullPartnersList.totalPages"/>
      <button class="bb-button-dashed" @click.stop="newPartner()">
        <i class="icon-cross"></i>
        Add new
      </button>
      <Pagination :data="fullPartnersList" :getQuery="getPartners" :limit="defLimit" class="bb-pagination"/>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import {balancePartnersTable, balancePartnersTableColumns} from '@/constants/TablesOptions/balancePartnersTable'
import balancePartnersApi from '@/api/BalancePartners/api'
import Pagination from '@/components/Main/Pagination/Pagination'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import _ from 'lodash'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import ContactsApi from '@/api/Contacts/api'

export default {
  name: 'BalancePartners',
  components: {
    Table,
    TotalCard,
    CustomSelect,
    Pagination,
    LoaderFly
  },
  data: function () {
    return {
      partnersList: [],
      loaderRun: false,
      fullPartnersList: '',
      defLimit: 30,
      placeholderSelect: 'Partner name',
      options: balancePartnersTable,
      uniqPartnerName: [],
      partnersName: [],
      totalsInvoicesCard: {
        totalAmountAED: {
          id: 4,
          title: 'TOTAL AMOUNT',
          icon: 'icon-coins',
          sum: 0
        }
      }
    }
  },
  computed: {
    balancePartnersColumnsData: {
      get: function () {
        return this.$store.getters.balancePartnersColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setBalancePartnersColumnsData', data)
      }
    },
    balancePartnersRowsData: {
      get: function () {
        return this.$store.getters.balancePartnersRowsData
      },
      set: function (data) {
        this.$store.dispatch('setBalancePartnersRowsData', data)
      }
    }
  },
  methods: {
    setPartner (item) {
      if (item && item.id !== 'all') {
        this.getPartners({query: '&partnerName[]=' + item.id})
      } else {
        this.getPartners({limit: this.defLimit})
      }
    },
    newPartner () {
      const partner = {
        partnerName: '',
        projectName: '',
        clientName: '',
        amountAED: '',
        paid: false,
        newMode: true,
        create: this.createPartner
      }
      const newHave = _.find(this.balancePartnersRowsData, {newMode: true})
      if (newHave) {
        return
      }
      this.balancePartnersRowsData.push(partner)
    },
    addActions () {
      _.forEach(this.balancePartnersColumnsData, item => {
        if (item.actions) {
          item.actions.delete = this.deletePartner
          item.actions.edit = this.editPartner
        }
      })
    },
    updateUniqPartners (names) {
      const partners = []
      names.forEach(id => {
        const partner = _.find(this.balancePartnersRowsData, {partnerName: {id: id}}) || {}
        if (partner.partnerName) {
          partner.partnerName.name = partner.partnerName.nickName
          partners.push(partner.partnerName)
        }
      })
      this.partnersName = _.sortBy(partners, ['nickName'])
    },
    getPartners ({query, limit, page}, update) {
      this.loaderRun = true
      balancePartnersApi.getPartnersBalance({query, limit, page})
        .then((resp) => {
          this.fullPartnersList = resp.data
          this.balancePartnersRowsData = resp.data.partners
          this.addActions()
          this.loaderRun = false
          if (!query || update) this.updateUniqPartners(resp.data.uniguepartnerName)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createPartner (partner) {
      const idPartner = _.get(partner, 'originpartnerName.id', '')
      partner.partnerName = idPartner
      balancePartnersApi.createPartnersBalance(partner)
        .then((resp) => {
          const select = this.$refs.partnersName
          if (select) {
            select.delActiveItem()
          }
          this.getPartners({limit: this.defLimit})
          this.getPartnersTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editPartner (partner) {
      const idPartner = _.get(partner, 'originpartnerName.id', '')
      const oldPartner = _.get(partner, 'partnerName', {})
      partner.partnerName = idPartner || oldPartner.id
      const index = _.findIndex(this.balancePartnersRowsData, {id: partner.id})
      balancePartnersApi.editPartnersBalance(partner)
        .then((resp) => {
          const updatePartner = resp.data
          updatePartner.partnerName = partner.originpartnerName || oldPartner
          this.balancePartnersRowsData.splice(index, 1, updatePartner)
          this.getPartners({limit: this.defLimit, page: this.fullPartnersList.page})
          this.getPartnersTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getPartnersTotal () {
      balancePartnersApi.getPartnersBalanceTotal()
        .then((resp) => {
          this.totalsInvoicesCard.totalAmountAED.sum = resp.data.totalAmountAED
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deletePartner (id) {
      const index = _.findIndex(this.balancePartnersRowsData, {id: id})
      balancePartnersApi.deletePartnersBalance(id)
        .then((resp) => {
          this.balancePartnersRowsData.splice(index, 1)
          const select = this.$refs.partnersName
          if (select) {
            select.delActiveItem()
          }
          this.getPartners({limit: this.defLimit})
          this.getPartnersTotal()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getContactsList ({limit, page, query, contactType}) {
      this.loaderRun = true
      ContactsApi.getContactsList({limit, page, query, contactType})
        .then((resp) => {
          const clients = _.filter(resp.data.clients, item => item) || []
          const clientSetName = clients.map(client => {
            client.name = client.nickName
            return client
          })
          this.partnersList = _.sortBy(clientSetName, ['nickName'])
          this.balancePartnersColumnsData.forEach(item => {
            if (item.listName === 'partnersList') {
              item.list = this.partnersList
            }
          })
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.balancePartnersColumnsData = balancePartnersTableColumns
    this.addActions()
    this.getPartnersTotal()
    this.getPartners({limit: this.defLimit})
    this.getContactsList({limit: 1000, contactType: 2})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/_variables";
  @import "../../../../sass/mixins";

  .bb-partners-balance {
    @include global-font;

    &-header {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 15px;
      position: relative;
      z-index: 2;

      &-select {
        align-self: flex-end;
        width: 233px;
        height: 42px;
      }

      &-total {
       min-width: 210px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Income/BalancePartners/BalancePartners.vue